export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 pt-14 pb-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <a href="#hero" className="font-heading text-xl font-bold text-primary-400 tracking-wide">
              51暗网
            </a>
            <p className="text-foreground-600 text-xs mt-3 leading-relaxed">
              中文暗网指南第一站，提供暗网入门、暗网浏览器推荐、Tor浏览器下载、暗网网址导航与深度网安全访问全攻略。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-300 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors duration-200">暗网指南索引</a>
              <a href="#carousel" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors duration-200">焦点专题</a>
              <a href="#updates" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors duration-200">最新动态</a>
              <a href="#faq" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors duration-200">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-300 mb-4">热点话题</h4>
            <div className="flex flex-col gap-2">
              <a href="#carousel" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors duration-200">暗网入门指南</a>
              <a href="#carousel" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors duration-200">Tor浏览器教程</a>
              <a href="#carousel" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors duration-200">暗网安全访问</a>
              <a href="#updates" className="text-foreground-600 text-xs hover:text-primary-400 transition-colors duration-200">吃瓜爆料聚合</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-300 mb-4">合作伙伴</h4>
            <p className="text-foreground-700 text-xs leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="mt-4">
              <h4 className="font-heading text-sm font-semibold text-foreground-300 mb-3">联系方式</h4>
              <div className="flex flex-col gap-1.5">
                <span className="text-foreground-600 text-xs">
                  <i className="ri-mail-line mr-1.5"></i>contact@51darkweb.example.com
                </span>
                <a href="#contact" className="text-primary-400 text-xs hover:text-primary-300 transition-colors duration-200">
                  <i className="ri-send-plane-line mr-1.5"></i>匿名投稿通道
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-700 text-xs">
            &copy; 2026 51暗网 · 本站内容仅供教育与研究参考
          </p>
          <div className="flex items-center gap-4">
            <span className="text-foreground-700 text-xs">暗网安全访问 · Tor浏览器 · 深度网指南</span>
          </div>
        </div>
      </div>
    </footer>
  );
}